import { render } from "./Auth-Router.vue?vue&type=template&id=5d2d52a6&ts=true"
import script from "./Auth-Router.vue?vue&type=script&lang=ts"
export * from "./Auth-Router.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__